import React from "react";
import { useSelector,useDispatch } from "react-redux";
import { actionCreators } from "../redux/remainingSessionsSagas";

export const UpdateButtons = ({ params, disableUpdateButton }) => {
  const dispatch = useDispatch();
  const isLoading = useSelector((state) => state.sessions.isLoading);
  const filtersDirty = useSelector((state) => state.sessions.filtersDirty);

  const resetData = () => {
    dispatch(actionCreators.resetData());
    dispatch(actionCreators.fetchCurrentUser(params));
  };
  if (filtersDirty & !isLoading) {
    return (
      <div className="action-buttons">
        <button
          className="submit"
          disabled={disableUpdateButton}
          onClick={() => dispatch(actionCreators.updateData())}
        >
          Update
        </button>
        <button className="submit reset" onClick={resetData}>
          Reset
        </button>
      </div>
    );
  }
  return null;
};
